"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSliderProps = exports.usePaginationProps = exports.useNavigationProps = exports.useAutoplayProps = void 0;
var _react = require("react");
var _constants = require("./constants");
const useAutoplayProps = ({
  enabled,
  interval
} = {}) => (0, _react.useMemo)(() => ({
  enabled: enabled ?? false,
  interval: interval ?? 5000
}), [enabled, interval]);
exports.useAutoplayProps = useAutoplayProps;
const useNavigationProps = ({
  size,
  position,
  enableKeyboard,
  height,
  showArrows
} = {}) => (0, _react.useMemo)(() => ({
  enableKeyboard: enableKeyboard ?? true,
  height: height ?? '100%',
  position: position ?? 'inside',
  showArrows: showArrows ?? true,
  size: size ?? 'medium'
}), [enableKeyboard, height, position, showArrows, size]);
exports.useNavigationProps = useNavigationProps;
const usePaginationProps = ({
  maxVisibleItems,
  position,
  show,
  style
} = {}) => (0, _react.useMemo)(() => ({
  maxVisibleItems: maxVisibleItems ?? _constants.MAX_VISIBLE_PAGINATION_ITEMS,
  position: position ?? 'inside',
  show: show ?? true,
  style: style ?? 'dots'
}), [maxVisibleItems, position, show, style]);
exports.usePaginationProps = usePaginationProps;
const useSliderProps = ({
  slides,
  loop,
  ...rest
} = {}) => {
  const loopRef = (0, _react.useRef)(loop);
  const restRef = (0, _react.useRef)(rest);
  const slidesRef = (0, _react.useRef)(slides);
  return (0, _react.useMemo)(() => ({
    loop: loopRef.current ?? true,
    slides: typeof slidesRef.current === 'object' ? {
      perView: 1,
      ...slidesRef.current
    } : slidesRef.current,
    ...restRef.current
  }), []);
};
exports.useSliderProps = useSliderProps;
